import CadastroProdutoModal from './CadastroProdutoModal';

export default CadastroProdutoModal;
